export default "__VITE_ASSET__98elgShV__"